import { useLanguage } from "../../context/LanguageContext";
import { useAuthContext } from "../../context/context";
import SubscriptionPlan from "../Subscription/SubscriptionPlan";
import { TbLogout } from "react-icons/tb";

const SubscriptionExpiredPopup = () => {
  const { copy } = useLanguage();
  const { logout } = useAuthContext();

  return (
    <div className="fixed inset-0 bg-black/30 bg-opacity-50 flex items-start sm:items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg p-2 relative">
        <button
          onClick={logout}
          className="absolute top-4 right-4 w-8 h-8 p-2 flex items-center justify-center transition ease-in-out duration-300 icon-base z-10 cursor-pointer hover:drop-shadow-md hover:scale-110"
          title="Logout"
        >
          <TbLogout size={24} />
        </button>

        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-4">
            {copy.profile.subscription.trial_expired}
          </h2>
          <p className="text-sm sm:text-base">
            {copy.profile.subscription.trial_expired_desc}
          </p>
        </div>

        <SubscriptionPlan isPopup={true} isHighlighted={true} />
      </div>
    </div>
  );
};

export default SubscriptionExpiredPopup;
